module.exports = __webpack_public_path__ + "d8ba2e24d2d88ab944218a4a435cb748.mp4";